import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from './Logo';
const MobileBottomNav = ({ onChatToggle }) => {
    const location = useLocation();
    const { isAuthenticated, user } = useAuth();
    // Only show for Elite subscribers
    const isEliteUser = user?.subscriptionTier === 'elite';
    // Don't show on landing page or auth pages
    if (!isAuthenticated || location.pathname === '/' ||
        location.pathname.includes('/login') || location.pathname.includes('/register')) {
        return null;
    }
    const navItems = [
        {
            path: '/dashboard',
            icon: 'fa-home',
            label: 'Home',
            isActive: location.pathname === '/dashboard'
        },
        {
            path: '/dashboard/my-bets',
            icon: 'fa-list-check',
            label: 'Bets',
            isActive: location.pathname.includes('/my-bets')
        },
        {
            path: '/dashboard/performance',
            icon: 'fa-chart-bar',
            label: 'Stats',
            isActive: location.pathname.includes('/performance')
        },
        {
            path: '/profile',
            icon: 'fa-user',
            label: 'Profile',
            isActive: location.pathname.includes('/profile')
        }
    ];
    // Add AI chat item for Elite users
    if (isEliteUser && onChatToggle) {
        navItems.push({
            path: '#',
            icon: '',
            label: 'AI',
            isActive: false,
            isChat: true
        });
    }
    return (_jsx("div", { className: "mobile-bottom-nav d-md-none", children: _jsx("div", { className: "mobile-bottom-nav-container", children: navItems.map((item, index) => (item.isChat ? (_jsxs("button", { onClick: onChatToggle, className: "mobile-nav-item chat-button", children: [_jsx(Logo, { width: 20, height: 20, style: {
                            color: '#ffd700',
                            filter: 'drop-shadow(0 2px 4px rgba(255,215,0,0.5))'
                        } }), _jsx("span", { className: "nav-label", children: item.label })] }, `chat-${index}`)) : (_jsxs(Link, { to: item.path, className: `mobile-nav-item ${item.isActive ? 'active' : ''}`, children: [_jsx("i", { className: `fas ${item.icon}` }), _jsx("span", { className: "nav-label", children: item.label })] }, item.path)))) }) }));
};
export default MobileBottomNav;
